'use strict';

import { elementResizer } from "@ncr-digital-banking/web-js-lib/dist/ncr-js.cjs.js";



//:::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
//:::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

    clickableDiv();
    
    if (document.querySelector('.band-menu-panel')) document.querySelector('.band-menu-panel').classList.add('panel-overlay');
    if(document.querySelector('.band-login-panel')) document.querySelector('.band-login-panel').classList.add('panel-overlay', 'panel-off-1200');

    var panel2 = document.querySelectorAll('.menu-panel-level-2');
    if(panel2){
      panel2.forEach(function(element) {
        element.classList.add('panel-off-900', 'panel-accordion');
      });
    }


    var panel3 = document.querySelectorAll('.menu-panel-level-3');
    if(panel3){
      panel3.forEach(function(element) {
        element.classList.add('panel-off-900', 'panel-accordion');
    });
    }
  

  if(document.querySelector('header .feature.search [ncr-panel]')) document.querySelector('header .feature.search [ncr-panel]').classList.add('panel-off-1');


    
if (document.querySelector('.menu-panel')){
  document.querySelector('.menu-panel').classList.add('panel-overlay');
  document.querySelector('.login-panel').classList.add('panel-overlay');

  var panel2 = document.querySelectorAll('.menu-list-level-2');
  panel2.forEach(function(element) {
    element.classList.add('panel-off-900', 'panel-accordion');
  });

  var panel3 = document.querySelectorAll('menu-list-level-3');
  panel3.forEach(function(element) {
      element.classList.add('panel-off-900', 'panel-accordion');
  });

document.querySelector('header .feature.search [ncr-panel]').classList.add('panel-overlay');

}
  // font awesome
  FontAwesome.library.add(customIcons, ncrIcons)

  //utils
  utils();

  //resizer
  elementResizer('.resizer', {
    minWidth: 300
  });

  elementResizer('.feature-wrap-quicklinks-1',{
    qty: 4,
  });

  elementResizer('.feature-wrap-promos-1',{
    qty: 3,
  });

  elementResizer('.feature-wrap-rates-1',{
    qty: 3,
  });

  elementResizer('.feature-wrap-testimonials-1',{
    qty: 4,
  });

  elementResizer('.band-column-block',{
    child: '.zone-column-block',
    minWidth: 500
  })
  elementResizer('.zone-column-block',{
    child: '.feature-wrap-column-block',
    minWidth: 500
  })
  elementResizer('.feature-wrap-column-block',{
    child: '.feature-wrap-column-block > .feature',
    minWidth: 500
  })
 
  //slider
  ncrSlider(".ncr-slider")
  ncrSlider(".band-standard-custom-block .slider")

  // cover image
  moveImageToBg('.cover-image',{
    destroyBelow: "",
    detectDistance: 0,
    pushContentDown: false,
    bgType: "cover"//default
  });

  // tabtrap
  // tabTrapping();
  jqueryTabTrapping(); 


  // move utilities
  moveElementAround('header .band-utility-1 .feature-wrap', {
    insideBefore: 'header .band-menu-panel .feature-wrap-menu',
    returnBelow: 900,  // Width in pixels
  });

  moveElementAround('header .band-utility-2 .feature-wrap', {
    insideBefore: 'header .band-menu-panel .feature-wrap-menu',
    returnBelow:9999,  // Width in pixels
  });
  
  //effect on scroll
  // effectOnScroll('header', {
  //   detectDistance: 0,
  //   pushContentDown: true,
  //   contentToPush: 'main',
  //   fixed: true,
  // });


    effectOnScroll('.band-rates-1 .feature-padding', {
      detectDistance: .5,
    });

    effectOnScroll('.band-quicklinks-1 .feature-padding', {
      detectDistance: .5,
    });

    effectOnScroll('.band-promos-1 .feature-padding', {
      detectDistance: .5,
    });

    // effectOnScroll('footer .feature-wrap', {
    //   detectDistance: .5,
    //   pushContentDown: false,
    // });
  
  

  //Moves Breadcrumbs outside of <main> so that you can have a 2 column layout
   document.querySelectorAll('.col-main div[class*="band-breadcrumbs"]').forEach(function(element) {
    document.querySelector('main').prepend(element);
  });
 

  //Moves Content Hero outside of <main> so that you can have a 2 column layout
  document.querySelectorAll('.col-main div[class*="content-hero"]').forEach(function(element) {
    document.querySelector('main').prepend(element);
  });

  
  // //Moves Blog Header outside of <main> so that you can have a 2 column layout
  document.querySelectorAll('.col-main div[class*="blog-header"]').forEach(function(element) {
    document.querySelector('main').prepend(element);
  });

  if(document.querySelector('.col-side')) document.querySelector('.col-side').classList.add('show');
  if(document.querySelector('.col-main')) document.querySelector('.col-main').classList.add('show');

  // :::::::::::::::::::::::::::::::::::::::::::::   End   ::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
  // ::::::::::::::::::::::::::::::::::::::::::::   Custom   ::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
// JavaScript to handle the back-to-top button functionality
document.addEventListener('DOMContentLoaded', function () {
    const backToTopButton = document.getElementById('back-to-top');
    // Show or hide the button based on the scroll position
    window.addEventListener('scroll', function () {
        if (window.pageYOffset > 300) {
            backToTopButton.classList.add('show');
        } else {
            backToTopButton.classList.remove('show');
        }
    });
    // Scroll back to the top smoothly when the button is clicked
    backToTopButton.addEventListener('click', function () {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    });
});


document.addEventListener('DOMContentLoaded', function () {
  const links = document.querySelectorAll('.routing-number');
  links.forEach(link => {
      link.addEventListener('click', function (event) {
          event.preventDefault(); // Prevent the default link behavior
          const label = this.querySelector('.text:not(.number)').textContent;
          const routingNumber = this.querySelector('.number').textContent;
          navigator.clipboard.writeText(routingNumber)
              .then(() => alert(`${label}${routingNumber} copied!`))
              .catch(err => console.error('Failed to copy routing number: ', err));
      });
  });
});
